import clsx from "clsx";

export const Callout = ({ callout }) => {
  if (!callout || !callout.active || !callout.text) {
    return null;
  }

  return (
    <p className={clsx('ticket__callout', `ticket__callout--style-${callout.style}`)}>
      {callout.text}
    </p>
  )
}
